import AjaxService from "services/base/Ajax.service";

class AuthService extends AjaxService {
  async getAuthOrganizations(email, password, fromAdmin = false) {
    return this.post("/auth/organizations", { email, password, fromAdmin });
  }

  async login(email, password, organizationId) {
    return this.post("/auth/signin", { email, password, organizationId });
  }

  async adminLogin(email, password, organizationId) {
    return this.post("/auth/admin/signin", { email, password, organizationId });
  }

  async registerUser(userCode, password) {
    return this.post("/auth/register", { userCode, password });
  }

  async forgotPassword(email) {
    return this.post("/auth/password/forgot", { email });
  }

  async validateCode(userCode) {
    return this.post("/auth/validateCode", { userCode });
  }
}

export default new AuthService();
